import { TokenDescriptor } from '../types';

export const TOKEN_KEY_ATTR = 'data-token-key';
export const TOKEN_MATCH_ATTR = 'data-token-match';

export const buildTokenElement = (
  key: string,
  match: string,
  descriptor: TokenDescriptor,
): HTMLSpanElement => {
  const span = document.createElement('span');
  span.setAttribute(TOKEN_KEY_ATTR, key);
  span.setAttribute(TOKEN_MATCH_ATTR, match);
  span.setAttribute('contenteditable', 'false');
  span.setAttribute('role', 'img');
  span.setAttribute('aria-label', descriptor.text);
  span.className = descriptor.className ?? '';
  span.textContent = descriptor.text;
  return span;
};

export const updateTokenElement = (
  element: HTMLElement,
  descriptor: TokenDescriptor,
) => {
  if (element.textContent !== descriptor.text) {
    element.textContent = descriptor.text;
  }
  const nextClass = descriptor.className ?? '';
  if (element.className !== nextClass) element.className = nextClass;
  if (element.getAttribute('aria-label') !== descriptor.text) {
    element.setAttribute('aria-label', descriptor.text);
  }
};

export const getTokenAttrs = (
  element: HTMLElement,
): { key: string; match: string } => {
  const key = element.getAttribute(TOKEN_KEY_ATTR);
  const match = element.getAttribute(TOKEN_MATCH_ATTR);
  if (key === null || match === null) {
    throw new Error('Token element is missing required data attributes');
  }
  return { key, match };
};
